import { moveSortItem } from '@renderer/utils/sort-preferences'

export interface PinnedTodoDropTarget {
  section?: 'pinned' | 'todos'
  id: string | null
  placement: 'before' | 'after'
}

export function placeTodoInPinned(order: Array<string>, source: string, target: PinnedTodoDropTarget): Array<string> {
  if (target.section === 'todos') {
    return order.filter((id) => id !== source)
  }
  if (target.id === null) {
    return [source, ...order.filter((id) => id !== source)]
  }
  if (!order.includes(target.id)) {
    return order
  }
  const withSource = order.includes(source) ? order : [...order, source]
  return moveSortItem(withSource, source, target.id, target.placement)
}
